module.exports = __webpack_public_path__ + "img/diagnosis_overlay.ed97199f.png";